import { ProgressSpinner } from "primereact/progressspinner";
import { useClients } from "../hooks/queries";
import Dashboard from "../Layout/Dashboard";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { SelectButton } from "primereact/selectbutton";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateClient } from "../services/clients";
import { useContext, useState, useEffect } from "react";
import { ToastContext } from "../ToastContext";
import { UserRole } from "../constants";

export default function ScaleSelectClient() {
  const { data: clients, isLoading } = useClients();
  const role = localStorage.getItem("role");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isAdminOrMaster = role === UserRole.MASTER || isAdmin;

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const toastRef = useContext(ToastContext);

  const updateClientMutation = useMutation({
    mutationFn: updateClient,
    onSuccess: ({ type, message }, { clientId, data }) => {
      if (type === "success") {
        queryClient.invalidateQueries({ queryKey: ["client"] });
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
          life: 3000,
        });
        setEditStates((prev) => ({
          ...prev,
          [clientId]: data.can_edit_scale ? "Si" : "No",
        }));
      } else {
        console.error("Error updating client:", message);
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
          life: 3000,
        });
      }
    },
  });

  // Local state to track can_edit_scale per client
  const [editStates, setEditStates] = useState({});

  // Sync local state with clients data
  useEffect(() => {
    if (clients) {
      const initial = {};
      clients.forEach((c) => {
        initial[c.id] = c.can_edit_scale ? "Si" : "No";
      });
      setEditStates(initial);
    }
  }, [clients]);

  return (
    <Dashboard headerTitle="Baremos">
      <h1 className="text-xl">
        Seleccione el cliente para consultar su baremo
      </h1>
      {isLoading && <ProgressSpinner />}
      <DataTable value={clients || []}>
        <Column field="name" header="Cliente" />
        <Column
          header="Acción"
          body={(item) => (
            <Button
              icon="pi pi-eye"
              label="Ver"
              onClick={() => navigate(`${item.id}`)}
            />
          )}
        />
        {isAdminOrMaster && (
          <Column
            header="¿Clínica puede editar baremo?"
            body={(item) => (
              <SelectButton
                value={
                  editStates[item.id] || (item.can_edit_scale ? "Si" : "No")
                }
                options={["Si", "No"]}
                disabled={updateClientMutation.isPending}
                onChange={(e) => {
                  setEditStates((prev) => ({ ...prev, [item.id]: e.value }));
                  const canEdit = e.value === "Si";
                  updateClientMutation.mutate({
                    clientId: item.id,
                    data: { can_edit_scale: canEdit },
                  });
                }}
              />
            )}
          />
        )}
      </DataTable>
    </Dashboard>
  );
}
